import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock3 } from "lucide-react";
import { shopifyFetch, COLLECTIONS_QUERY, nodes } from "@/lib/shopify";

export default function Footer() {
  const [collections, setCollections] = useState([]);

  useEffect(() => {
    shopifyFetch(COLLECTIONS_QUERY, { first: 6 })
      .then((d) => setCollections(nodes(d.collections).filter((c) => c.handle !== "frontpage")))
      .catch(() => {});
  }, []);

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-void">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-12 px-5 py-16 sm:px-8 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <Clock3 className="h-6 w-6 text-amber" />
            <span className="font-display text-lg font-black tracking-tight text-ivory">
              WEIRD O'CLOCK
            </span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-ivory/50">
            Curated surreal clocks and eccentric home decor. Functional art for
            homes that refuse to be beige. Checkout and fulfilment handled
            securely by Shopify.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-amber">Shop</p>
          <ul className="mt-4 space-y-2.5">
            <li>
              <Link to="/shop" data-testid="footer-link-shop-all" className="text-sm text-ivory/60 hover:text-amber">
                Shop All
              </Link>
            </li>
            {collections.slice(0, 4).map((c) => (
              <li key={c.id}>
                <Link
                  to={`/collections/${c.handle}`}
                  data-testid={`footer-link-${c.handle}`}
                  className="text-sm text-ivory/60 hover:text-amber"
                >
                  {c.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-amber">Help</p>
          <ul className="mt-4 space-y-2.5">
            <li>
              <Link to="/contact" data-testid="footer-link-contact" className="text-sm text-ivory/60 hover:text-amber">
                Contact us
              </Link>
            </li>
            <li>
              <Link
                to="/shipping-returns"
                data-testid="footer-link-shipping"
                className="text-sm text-ivory/60 hover:text-amber"
              >
                Shipping & returns
              </Link>
            </li>
            <li>
              <Link to="/search" data-testid="footer-link-search" className="text-sm text-ivory/60 hover:text-amber">
                Search the store
              </Link>
            </li>
            <li>
              <Link to="/privacy" data-testid="footer-link-privacy" className="text-sm text-ivory/60 hover:text-amber">
                Privacy policy
              </Link>
            </li>
            <li>
              <Link to="/terms" data-testid="footer-link-terms" className="text-sm text-ivory/60 hover:text-amber">
                Terms of service
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="overflow-hidden border-t border-white/10 py-6">
        <p className="text-center font-display text-[13vw] font-black leading-none tracking-tight text-white/[0.04] md:text-[9vw]">
          WEIRD O'CLOCK
        </p>
      </div>
      <div className="border-t border-white/10 py-5 text-center font-mono2 text-[10px] uppercase tracking-[0.3em] text-ivory/30">
        <p data-testid="footer-business-identity">
          Weird O'Clock · Australian owned and operated · Contact:{" "}
          <a href="mailto:sorellinabali@gmail.com" className="hover:text-amber">
            sorellinabali@gmail.com
          </a>{" "}
          · ABN: [pending registration]
        </p>
        <p className="mt-2">© {new Date().getFullYear()} Weird O'Clock — time is an illusion, shipping is real</p>
      </div>
    </footer>
  );
}
